import React, { useState, useEffect } from 'react';
import classes from './MoveArrow.module.css';
import ArrowCircleUpRoundedIcon from '@mui/icons-material/ArrowCircleUpRounded';

const ScrollTopHanlder = () => {
    window.scrollTo(0, 0);
}  



const MoveArrow = () => {
    const [scrollY, setScrollY] = useState(0);
    const [lastScrollY, setLastScrollY] = useState(0);
    const [showIcon, setShowIcon] = useState(false);

    useEffect( () => {
        const handleScroll = () => {
            setScrollY(window.scrollY);
        }
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        }
    }, []);

    useEffect( () => {
        if(scrollY > lastScrollY) {
            setShowIcon(false);
        } else if(scrollY < lastScrollY) {
            setShowIcon(true);
        }
        else if(scrollY === 0 ) {
            setShowIcon(false);
        }
        setLastScrollY(scrollY);
    }, [scrollY, lastScrollY]);

    return (
        <>
        {showIcon ? 
            <div className={classes.moveArrow} onClick={ScrollTopHanlder}>
                <div className={classes.iconArea}>
                    <ArrowCircleUpRoundedIcon fontSize='large'/>
                </div>
            </div>
            : null}
        </>

    )
}

export default MoveArrow;